import { useLazyQuery } from 'data-fetching-client';
import { useCallback, useMemo } from 'react';
import { VALIDATE_RSS_FEED_URL } from '../queries/rss';
export default function useRSSFeedValidation({
  onCompleted,
  onError
}) {
  const [validateRSSFeedURL, {
    called,
    data,
    error,
    loading
  }] = useLazyQuery(VALIDATE_RSS_FEED_URL, {
    onCompleted: onCompleted ? response => onCompleted(response.validation) : undefined,
    onError
  });
  const wrappedValidateRSSFeedURL = useCallback(url => void validateRSSFeedURL({
    variables: {
      url
    }
  }), [validateRSSFeedURL]);
  return useMemo(() => ({
    called,
    error,
    loading,
    validate: wrappedValidateRSSFeedURL,
    validationResult: data === null || data === void 0 ? void 0 : data.validation
  }), [called, data === null || data === void 0 ? void 0 : data.validation, error, loading, wrappedValidateRSSFeedURL]);
}